<script>
import { mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Ad Positions'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Ad Positions',
            includeDeleteAction: false
        };
    },

    computed: {
        labels() {
            return [
                { value: 'name', width: '150px' },
                { value: 'width', width: '150px' },
                { value: 'height', width: '150px' }
            ];
        },

        options() {
            return {
                addButton: false,
                csvExport: false,
                select: false
            };
        }
    },

    methods: {
        ...mapActions({
            getItems: 'adPositions/index',
            deleteItem: 'adPositions/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/ad-positions/${id}/ads`);
        }
    }
};
</script>
